/**
 * API 地址（与 web 项目 src/config/api.js 对齐）
 * - 开发：务必走相对路径 /api/*，由 devServer 代理到后端（同源，无 CORS）
 * - 勿在 .env.development 设置 VUE_APP_API_BASE 为 https 直连，否则会跨域
 * - 生产：未设置 VUE_APP_API_BASE 时直连 https://gwht.rgznypt.cn（同域部署或 Nginx 反代则无 CORS）
 */
const raw = process.env.VUE_APP_API_BASE;
const base = typeof raw === 'string' ? raw.trim() : '';
const isHttpBase = /^https?:\/\//i.test(base);
const isDev = process.env.NODE_ENV === 'development';

/** 是否使用相对路径 /api/*（由 devServer 或 Nginx 转发） */
export const useProxy =
  !isHttpBase && (isDev || base === '' || base === '/');

const API_BASE = useProxy ? '' : isHttpBase ? base : base || 'https://gwht.rgznypt.cn';

/** 后端域名，用于拼接相对路径图片等 */
export const BACKEND_ORIGIN = 'https://gwht.rgznypt.cn';

const PROXY_PATHS = {
  cert: '/api/cert',
  list: '/api/list',
  login: '/api/login',
  personalCenterCategory: '/api/personal-center-category',
  personalCenterCategoryList: '/api/personal-center-category-list'
};

const BACKEND_PATHS = {
  cert: '/api/index/getObtain',
  list: '/api/index/getList',
  login: '/api/index/login',
  personalCenterCategory: '/api/index/personalCenterCategory',
  personalCenterCategoryList: '/api/index/personalCenterCategoryList'
};

export function getApiUrl(key) {
  if (useProxy) {
    return PROXY_PATHS[key] || key;
  }
  return `${API_BASE}${BACKEND_PATHS[key] || key}`;
}
